<template>
  <div class="view">
    <div class="left">
      <uiList
        class="list"
        :items="items"
        :search="['locale.ru', 'locale.en']"
        :add="true"
        @click="select"
        @add="add"
      >
        <template v-slot:item="{ item }">
          <div class="list-item">
            {{ item.locale.ru || item.locale.en }}
          </div>
        </template>
      </uiList>
    </div>

    <div class="space-y-3 px-5 w-156">
      <div class="global-id">{{ selected.id }}</div>
      <uiDevider />

      <div class="flex space-x-3">
        <div class="flex-1">
          <uiInput v-model="selected.locale.ru" label="Название (RU)" />
          <div class="text-xs leading-tight opacity-40 pt-2">
            В Ru мы пишем в формате "Можно ли собаке/кошке <b>что-то</b>". Например,
            курицу (вместо курица)
          </div>
        </div>

        <div class="flex-1">
          <uiInput v-model="selected.locale.en" label="Название (EN)" />
          <div class="text-xs leading-tight opacity-40 pt-2">В En пишем как обычно :)</div>
        </div>

        <div class="flex-1">
          <uiInput v-model="selected.locale.he" label="Название (HE)" />
        </div>
      </div>

      <div class="flex space-x-3">
        <div class="flex-1">
          <uiTextarea v-model="selected.comment.ru" label="Комментарий (RU)" />
        </div>

        <div class="flex-1">
          <uiTextarea v-model="selected.comment.en" label="Комментарий (EN)" />
        </div>

        <div class="flex-1">
          <uiTextarea v-model="selected.comment.he" label="Комментарий (HE)" />
        </div>
      </div>


      <uiDevider />
      <div class="flex space-x-3">
        <uiDropdown
          class="w-50"
          v-model="selected.dog"
          label="Для собак"
          :options="['good', 'danger', 'bad']"
        />

        <uiDropdown
          class="w-50"
          v-model="selected.cat"
          label="Для кошек"
          :options="['good', 'danger', 'bad']"
        />
      </div>

      <div class="flex space-x-4 pt-5">
        <uiButton
          class="w-50"
          color="light"
          v-if="this.selected.id !== 'new'"
          :loading="loading"
          @click="remove"
        >
          Удалить
        </uiButton>

        <uiButton class="w-50" :loading="loading" @click="save">
          {{ button }}
        </uiButton>
      </div>
    </div>
  </div>
</template>

<script>
import { API } from '@/config'
import UiDevider from '../components/ui/uiDevider.vue'

function getDefaultSelected() {
  return {
    id: 'new',
    name: '',
    locale: {
      en: '',
      ru: '',
      he: '',
    },
    comment: {
      en: '',
      ru: '',
      he: '',
    },
    dog: '',
    cat: ''
  }
}

export default {
  name: 'PetFood',
  data () {
    return {
      loading: false,
      items: [],
      selected: getDefaultSelected()
    }
  },
  computed: {
    button () {
      if (this.selected.id === 'new') return 'Создать'
      return 'Сохранить'
    }
  },
  created () {
    this.selectNew()
    this.preload()
  },
  methods: {
    async preload () {
      if (this.items.length) return
      let { data } = await this.$http.get(API.SERVICES.petFood)
      if (!data || data.err) return this.$notify(data.err)
      this.items = data
    },
    select (e) {
      this.selected = structuredClone(e)
    },
    selectNew () {
      this.selected = getDefaultSelected()
    },
    add () {
      if (this.selected.id === 'new') return
      this.selectNew()
    },
    async save () {
      if (this.loading) return
      this.loading = true
      let payload = JSON.parse(JSON.stringify(this.selected))
      let { data } = await this.$http.post(API.SERVICES.petFood, payload)
      if (!data || data.err) {
        this.$notify(data.err)
        return (this.loading = false)
      }
      let index = this.items.findIndex(p => p.id === data.id)
      this.items.splice(index, 1, data)
      this.selected = data
      this.loading = false
      this.selectNew()
    },
    async remove () {
      let confirm = await this.$confirm(`Точно удаляем?`)
      if (!confirm) return
      if (this.loading) return
      this.loading = true
      let id = this.selected.id
      if (id === 'new') return
      let { data } = await this.$http.delete(API.SERVICES.petFood, { id })
      if (!data || data.err) {
        this.$notify(data.err)
        return (this.loading = false)
      }
      this.selectNew()
      let index = this.items.findIndex(p => p.id === id)
      this.items.splice(index, 1)
      this.loading = false
    }
  },
  components: { UiDevider }
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.view {
  display: flex;
}

.list {
  .list-item {
    display: block;
    font-size: 16px;
    position: relative;
  }
}
</style>
